import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { IWidgetConfigComponent } from 'src/app/models/dashboard/dashboard-widget.model';
import { ExceedanceComplianceFiltersComponent } from './exceedance-compliance-filters.component';
import {
    ExceedanceComplianceFilterValues,
    EXCEEDANCE_FILTER_DEFAULTS,
    configToFilterValues,
    filterValuesToConfig
} from './exceedance-compliance-widget.constants';

@Component({
    standalone: true,
    selector: 'app-exceedance-compliance-widget-config',
    imports: [ExceedanceComplianceFiltersComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './exceedance-compliance-widget-config.component.html'
})
export class ExceedanceComplianceWidgetConfigComponent implements OnInit, IWidgetConfigComponent {
    @Input() config: Record<string, unknown> = {};
    @Output() configChange = new EventEmitter<Record<string, unknown>>();

    filterValues: ExceedanceComplianceFilterValues = { ...EXCEEDANCE_FILTER_DEFAULTS };

    ngOnInit(): void {
        this.filterValues = configToFilterValues(this.config);
    }

    onFilterChange(values: ExceedanceComplianceFilterValues): void {
        this.filterValues = values;
        this.configChange.emit(filterValuesToConfig(values));
    }
}
